const formatter = new Intl.DateTimeFormat("en-US", {
  timeZone: "America/New_York",
});

/**
 * All Timestamps are based on the UTC time
 * that relates to midnight EST on the date in question.
 * Therefore, we want to make sure we are consistent with
 * date formatting to reflect the intended EST date of policies.
 * @param timestamp The timestamp to be formatted (ms or seconds — both handled)
 */
export const formatTimestamp = (timestamp: number): string => {
  // Timestamps stored in seconds (10-digit) are normalized to ms (13-digit).
  // A value below 1e10 (~Nov 2001 in ms) is treated as seconds-since-epoch.
  const ms = timestamp < 1e10 ? timestamp * 1000 : timestamp;
  return formatter.format(ms);
};
